// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getStructureItems as listStructureItemsAPI,
    getStructureItem as getStructureItemAPI,
    addStructureItem as addStructureItemAPI,
    updateStructureItem as updateStructureItemAPI,
    deleteStructureItem as deleteStructureItemAPI,
} from '../../helpers/';

import { structureItemApiResponseError, structureItemApiResponseSuccess } from './actions';
import { StructureItemActionTypes } from './constants';

function* getStructureItem({ payload: { id } }) {
    try {
        const response = yield call(getStructureItemAPI, id );
        const structureItem = response.data.data;
        yield put(structureItemApiResponseSuccess(StructureItemActionTypes.GET_STRUCTURE_ITEM, structureItem));
    } catch (error) {
        yield put(structureItemApiResponseError(StructureItemActionTypes.GET_STRUCTURE_ITEM, error));
    }
}

function* addStructureItem({payload:structureItem}){
    try{
        const response = yield call(addStructureItemAPI,{...structureItem})
        const structureItemData = response.data
        yield put(structureItemApiResponseSuccess(StructureItemActionTypes.ADD_STRUCTURE_ITEM,structureItemData))
    } catch(error){
        yield put(structureItemApiResponseError(StructureItemActionTypes.ADD_STRUCTURE_ITEM,error))
    }
}

function* updateStructureItem({payload:structureItem}){
    try{
        const response = yield call(updateStructureItemAPI,{...structureItem})
        const structureItemData = response.data.data
        yield put(structureItemApiResponseSuccess(StructureItemActionTypes.UPDATE_STRUCTURE_ITEM,structureItemData))
    }catch(error){
        yield put(structureItemApiResponseError(StructureItemActionTypes.UPDATE_STRUCTURE_ITEM,error))
    }
}
function* deleteStructureItem({payload:{id}}){
    try{
        const response = yield call(deleteStructureItemAPI,id)
        const structureItemData = response.data.id
        yield put(structureItemApiResponseSuccess(StructureItemActionTypes.DELETE_STRUCTURE_ITEM,structureItemData))
    }catch(error){
        yield put(structureItemApiResponseError(StructureItemActionTypes.DELETE_STRUCTURE_ITEM,error))
    }
}

/**
 * List contactos
 */
function* listStructureItems({payload:params}) {
    try {
        const response = yield call(listStructureItemsAPI, { ...params });
        const listaItems = response.data.data;
        yield put(structureItemApiResponseSuccess(StructureItemActionTypes.LIST_STRUCTURE_ITEMS, listaItems));
    } catch (error) {
        yield put(structureItemApiResponseError(StructureItemActionTypes.LIST_STRUCTURE_ITEMS, error));
    }
}


export function* watchGetStructureItem(): any {
    yield takeEvery(StructureItemActionTypes.GET_STRUCTURE_ITEM, getStructureItem);
}

export function* watchListStructureItems(): any {
    yield takeEvery(StructureItemActionTypes.LIST_STRUCTURE_ITEMS, listStructureItems);
}

export function* watchAddStructureItem():any{
    yield takeEvery(StructureItemActionTypes.ADD_STRUCTURE_ITEM,addStructureItem)
}
export function* watchUpdateStructureItem():any{
    yield takeEvery(StructureItemActionTypes.UPDATE_STRUCTURE_ITEM,updateStructureItem)
}
export function* watchDeleteStructureItem():any{
    yield takeEvery(StructureItemActionTypes.DELETE_STRUCTURE_ITEM,deleteStructureItem)
}


function* structureItemsSaga(): any {
    yield all([
        fork(watchGetStructureItem),
        fork(watchListStructureItems),
        fork(watchAddStructureItem),
        fork(watchUpdateStructureItem),
        fork(watchDeleteStructureItem),
    ]);
}

export default structureItemsSaga;
